// extracted by mini-css-extract-plugin
export default {"Container":"Skeleton_Container__2BV5y","left":"Skeleton_left__Ssils","right":"Skeleton_right__Tln3n"};